import { DarkMode, LightMode, Toggle, Typography } from '@it-incubator/ui-kit'

import { useAppDispatch, useAppSelector } from '../../../common/hooks'
import { selectIdDarkTheme, setIsDarkTheme } from '../../../features/dashboard'

import s from './ThemeSwitcher.module.css'

export const ThemeSwitcher = () => {
  const isDarkTheme = useAppSelector(selectIdDarkTheme)
  const dispatch = useAppDispatch()
  const onThemeToggle = (isDarkTheme: boolean) => {
    dispatch(setIsDarkTheme({ isDarkTheme }))
  }

  return (
    <span className={s.themeToggle}>
      <span className={s.imgContainer}>
        {isDarkTheme ? <LightMode size={16} /> : <DarkMode size={16} />}
      </span>
      <Toggle checked={isDarkTheme} className={s.toggle} onCheckedChange={onThemeToggle} />
    </span>
  )
}
